import { Dropdown, DropdownProps } from 'primereact/dropdown';

import { useSites } from '@/services/sites';

import './FertilizationSiteDropdown.css';

type FertilizationSiteDropdownProps = DropdownProps & {
  className?: string;
  label?: string;
  value?: { id: string } | string;
};

export const FertilizationSiteDropdown = ({
  className,
  label,
  value,
  ...dropdownProps
}: FertilizationSiteDropdownProps) => {
  const { data = [], isLoading } = useSites({ filter: 'fertilization' });
  const dropdownValue =
    typeof value === 'object' && value !== null
      ? value.id
      : value && value !== ''
        ? value
        : null;
  return (
    <div
      className={`fertilization-site-dropdown${label ? 'label-input-group' : ''} w-full`}
    >
      {label && <label>{label}</label>}
      <Dropdown
        appendTo="self"
        options={data}
        value={dropdownValue}
        optionLabel="name"
        optionValue="id"
        filter
        filterPlaceholder="Search"
        filterInputAutoFocus={true}
        loading={isLoading}
        showClear
        className={className}
        {...dropdownProps}
      />
    </div>
  );
};
